import React, { useContext, useEffect, useState } from 'react';
import { Dropdown } from '@core-ui/dropdown';
// @ts-ignore
import { RailContext } from '@cat/rail';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import {
  CSSObject,
  Theme,
  getFontWeight,
  forBrands,
} from '@core-ui/react-stitch';
import {
  getControlStyles,
  getMenuStyles,
  getOptionStyles,
} from './collaborators';
import { RangeFacetProps } from './types';

const RangeFacet = (props: RangeFacetProps) => {
  const { name, range, minOptions, maxOptions, displayName, getOptionLabel } =
    props;

  const rangeFacetStyle = (): CSSObject => ({
    justifyContent: 'center',
    display: 'flex',
    height: '250px',
  });

  const rangeFacetElementStyle = (): CSSObject => ({
    width: '6.25rem',
    '.range-facet-dropdown__dropdown': {
      marginTop: '7px',
    },
  });

  const setRangeFacetLabelStyleForBananaRepublic = (): CSSObject => ({
    fontSize: '0.875rem',
    fontWeight: getFontWeight('regular').fontWeight,
  });

  const rangeFacetLabelStyle = (theme: Theme) => ({
    ...theme.brandFont,
    margin: '1rem',
    color: theme.color.g2,
    ...(forBrands(theme, {
      br: setRangeFacetLabelStyleForBananaRepublic,
      brfs: setRangeFacetLabelStyleForBananaRepublic,
    }) as CSSObject),
  });

  const { onFacetChange } = useContext(RailContext);

  const [min, setMin] = useState(range.min);
  const [max, setMax] = useState(range.max);

  useEffect(() => {
    setMin(range.min);
    setMax(range.max);
  }, [range]);

  const publishFacetChange = (min: number, max: number) => {
    onFacetChange &&
      onFacetChange({
        isSelected: true,
        facetName: name,
        range: {
          min,
          max,
        },
      });
  };

  const handleMinChange = (selectedValue: number) => {
    publishFacetChange(selectedValue, range.max);
    setMin(selectedValue);
  };

  const handleMaxChange = (selectedValue: number) => {
    publishFacetChange(range.min, selectedValue);
    setMax(selectedValue);
  };

  const { enabledFeatures } = useContext(FeatureFlagsContext);
  const isBRcolor2023FFEnabled = enabledFeatures['br-colors-2023'];
  return (
    <div css={rangeFacetStyle}>
      <div key={`min-${name}`} css={rangeFacetElementStyle}>
        <Dropdown
          className="range-facet-dropdown"
          classNamePrefix="range-facet-dropdown"
          getOptionLabel={getOptionLabel}
          label={`Minimum ${displayName}`}
          /*
          // @ts-ignore */
          onChange={handleMinChange}
          options={minOptions}
          /*
          // @ts-ignore */
          placeholder={range.min}
          styles={{
            Control: getControlStyles(isBRcolor2023FFEnabled),
            Menu: getMenuStyles(isBRcolor2023FFEnabled),
            Option: getOptionStyles(isBRcolor2023FFEnabled),
          }}
          value={min}
        />
      </div>
      <div css={rangeFacetLabelStyle}>to</div>
      <div key={`max-${name}`} css={rangeFacetElementStyle}>
        <Dropdown
          className="range-facet-dropdown"
          classNamePrefix="range-facet-dropdown"
          getOptionLabel={getOptionLabel}
          label={`Maximum ${displayName}`}
          /*
          // @ts-ignore */
          onChange={handleMaxChange}
          options={maxOptions}
          /*
          // @ts-ignore */
          placeholder={range.max}
          styles={{
            Control: getControlStyles(isBRcolor2023FFEnabled),
            Menu: getMenuStyles(isBRcolor2023FFEnabled),
            Option: getOptionStyles(isBRcolor2023FFEnabled),
          }}
          value={max}
        />
      </div>
    </div>
  );
};

export default RangeFacet;
